import { useAllowances } from 'apps/employer_renewals/providers/AllowancesProvider'
import { SolidCircleCheckIcon, SolidCircleXIcon } from 'slab'

export default function BetterBenefitsSection ({ isOfferingDependentCoverage }: { isOfferingDependentCoverage: boolean }) {
  const { employerWillOfferQmeInRenewalYear } = useAllowances()

  return (
    <div className='bg-gray-50 p-6 space-y-4'>
      <h2 className='body text-gray-500'>Give your team even better benefits</h2>
      <div className='grid grid-cols-2 gap-6'>
        <div className='flex gap-2'>
          <div className='flex-shrink-0'>
            {employerWillOfferQmeInRenewalYear
              ? <SolidCircleCheckIcon className='w-4 h-4 my-0.5 text-green-400' />
              : <SolidCircleXIcon className='w-4 h-4 my-0.5 text-red-400' />}
          </div>
          <div>
            <span className='body'>
              Employees can{!employerWillOfferQmeInRenewalYear && "'t"} use leftover allowance
            </span>
            <p className='body-sm text-gray-500 mt-1'>
              {employerWillOfferQmeInRenewalYear
                ? "This won't impact your estimated costs"
                : 'Employees will only be able to cover up to the cost of their insurance plan and will not be able to use their allowance on co-pays and other qualified medical expenses'}
            </p>
          </div>
        </div>
        <div className='flex gap-2'>
          <div>
            {isOfferingDependentCoverage
              ? <SolidCircleCheckIcon className='w-4 h-4 my-0.5 text-green-400' />
              : <SolidCircleXIcon className='w-4 h-4 my-0.5 text-red-400' />}
          </div>
          <div>
            <span className='body'>
              Additional dependent coverage
            </span>
            <p className='body-sm text-gray-500 mt-1'>
              {!isOfferingDependentCoverage && 'Spouses and other dependents left with little to no coverage, increasing health and financial risk to employees\' families'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
